import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-df364288"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }

import {useSidebarStore} from "@/store/sidebar/sidebar";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopPanel',
  setup(__props) {

const sidebarStore = useSidebarStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['panel-container', _unref(sidebarStore).isOpen ? 'panel-container--sidebar-open' : 'panel-container--sidebar-close' ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})